import { render, staticRenderFns } from "./MemberTag.vue?vue&type=template&id=47a213ae&scoped=true&"
import script from "./MemberTag.vue?vue&type=script&lang=ts&"
export * from "./MemberTag.vue?vue&type=script&lang=ts&"
import style0 from "./MemberTag.vue?vue&type=style&index=0&id=47a213ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a213ae",
  null
  
)

export default component.exports